import { ICommandBase } from "@Alternatives/cqrs";

export class CreateStaticViewCommandV1 implements ICommandBase {
	$type: string = 'TCh.Domain.Alternatives.AlternativesViews.Commands.CreateStaticViewCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	Id: string;
	AlternativesListId: number;
	AlternativesIds: number[];
	Name: string;

	constructor(workspaceId: number, id: string, alternativesListId: number, alternativesIds: number[], name: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = id;
		this.AlternativesListId = alternativesListId;
		this.AlternativesIds = alternativesIds;
		this.Name = name;
	}

	static matchType(cmd: ICommandBase)	{
		return cmd.$type == 'TCh.Domain.Alternatives.AlternativesViews.Commands.CreateStaticViewCommandV1, TCh.Domain.Alternatives'
	}
}

export class CreateDynamicViewCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesViews.Commands.CreateDynamicViewCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	Name: string;
	FilterData: string;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, id: string, name: string, filterData: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = id;
		this.Name = name;
		this.FilterData = filterData;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Alternatives.AlternativesViews.Commands.CreateDynamicViewCommandV1, TCh.Domain.Alternatives'
	}
}

export class UpdateDynamicViewCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesViews.Commands.UpdateDynamicViewCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	Name: string;
	FilterData: string;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, id: string, name: string, filterData: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = id;
		this.Name = name;
		this.FilterData = filterData;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Alternatives.AlternativesViews.Commands.UpdateDynamicViewCommandV1, TCh.Domain.Alternatives'
	}
}

export class UpdateStaticViewCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesViews.Commands.UpdateStaticViewCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	Name: string;
	AlternativesIds: number[];

	constructor(workspaceId: number, projectId: number, alternativesListId: number, id: string, name: string, alternativesIds: number[])
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = id;
		this.Name = name;
		this.AlternativesIds = alternativesIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Alternatives.AlternativesViews.Commands.UpdateStaticViewCommandV1, TCh.Domain.Alternatives'
	}
}

export class AddAlternativesToStaticViewCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesViews.Commands.AddAlternativesToStaticViewCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	Id: string;
	AlternativesListId: number;
	AlternativesIds: number[];

	constructor(workspaceId: number, id: string, alternativesListId: number, alternativesIds: number[])
	{
		this.WorkspaceId = workspaceId;
		this.Id = id;
		this.AlternativesListId = alternativesListId;
		this.AlternativesIds = alternativesIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Alternatives.AlternativesViews.Commands.AddAlternativesToStaticViewCommandV1, TCh.Domain.Alternatives'
	}
}

export class RemoveAlternativesFromStaticViewCommandV1 implements ICommandBase {
	$type: string = 'TCh.Domain.Alternatives.AlternativesViews.Commands.RemoveAlternativesFromStaticViewCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	Id: string;
	AlternativesListId: number;
	AlternativesIds: number[];

	constructor(workspaceId: number, id: string, alternativesListId: number, alternativesIds: number[])
	{
		this.WorkspaceId = workspaceId;
		this.Id = id;
		this.AlternativesListId = alternativesListId;
		this.AlternativesIds = alternativesIds;
	}

	static matchType(cmd: ICommandBase)	{
		return cmd.$type == 'TCh.Domain.Alternatives.AlternativesViews.Commands.RemoveAlternativesFromStaticViewCommandV1, TCh.Domain.Alternatives'
	}
}

export class DeleteAlternativesViewCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesViews.Commands.DeleteAlternativesViewCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, viewDefId: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = viewDefId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesViews.Commands.DeleteAlternativesViewCommandV1, TCh.Domain.Alternatives';
	}
}

